
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    data: {},
    error: false,
    lastFetched: null,
};

// Try to load from localStorage
const saved = localStorage.getItem('home');
if (saved) {
    try {
        const parsed = JSON.parse(saved);
        initialState.data = parsed.data || {};
        initialState.lastFetched = parsed.lastFetched || null;
    } catch (err) {
        console.error('Error parsing localStorage home cache:', err);
    }
}

export const homeSlice = createSlice({
    name:'home',
    initialState:initialState,
    reducers:{
        HOME_FETCH_START:(state)=>{
            state.loading=true
        },
        HOME_FETCH_SUCCESS:(state,action)=>{
            state.loading=false
           state.data = action.payload;
            state.lastFetched = Date.now();

            // ✅ Save to localStorage
            localStorage.setItem('home', JSON.stringify({
                data: action.payload,
                lastFetched: Date.now()
            }));
            
        },
        HOME_FETCH_ERROR:(state)=>{
            state.error=true
        }
    }
});

export const { HOME_FETCH_START,HOME_FETCH_SUCCESS,HOME_FETCH_ERROR }=homeSlice.actions;
export default homeSlice.reducer;